/**
 * Mode flag for the public share (permalink) dashboard viewer.
 *
 * The viewer boots inside the export bundle with exportVars.isPublicShare set
 * by the server. Widget chrome that must not be exposed to anonymous viewers
 * (options menu, header filter/calendar icons, data probe, dev progress bar)
 * checks this flag so it can be centrally re-enabled later if needed.
 */
export class PublicShareService {
  /**
   * @returns {boolean}
   */
  static isPublicShareView() {
    return !!window.exportVars?.isPublicShare;
  }

  /**
   * Whether the link opts in to the read-only widget-header indicators (applied
   * filter + date-range override summaries) on the public viewer. Off by
   * default; alerts and annotations are never exposed regardless.
   *
   * @returns {boolean}
   */
  static showWidgetIndicators() {
    return !!window.exportVars?.share?.show_widget_indicators;
  }

  /**
   * Whether the shared dashboard holds product-assigned sections or widgets.
   * Those are visible only while the client holds the product, and that window
   * is resolved server-side at render, so a date change has to go back through
   * the server rather than only re-fetching widget data (TR-7637).
   *
   * @returns {boolean}
   */
  static hasDateScopedVisibility() {
    return !!window.exportVars?.share?.date_scoped_visibility;
  }
}
